import makeStyles from '@mui/styles/makeStyles';
import { colors } from '@procore/core-react';

export const useStyles = makeStyles({
  outline: { position: 'relative', padding: '0px 5px 0px 0px' },
  check: { position: 'absolute', top: '2px', left: '3px', color: colors.white },
  text: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '19px',
    letterSpacing: '0px',
  },
});
